import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import FeatureGrid from './components/FeatureGrid';
import CategoryGrid from './components/CategoryGrid';
import SafetySection from './components/SafetySection';
import BlogSection from './components/BlogSection';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <FeatureGrid />
        <CategoryGrid />
        <SafetySection />
        <BlogSection />
        <CTASection />
        <TestimonialSection />
      </main>
      <Footer />
    </>
  );
}